// extracted by mini-css-extract-plugin
export default {"wrapper":"index__wrapper__3oQgs"};